import { observer } from "mobx-react-lite";
import styled from "styled-components";
import useNavigation from "../../hooks/useNavigation";
import { useStores } from "../../models";
import { formatPrice, genPrivacyChatID, staticUrl } from "../../utils";
import { TakeOrderStatus } from "../../proto/nbchat-proto";
import Avatar from "../Avatar";
import { ToastError } from "../Toast";
import { orderStatusText, paymentMethodTextMap, settleStatuses, cancelStatuses, timeoutStatuses } from "./orderStatus";

const Box = styled.div`
  padding: 10px 0;
  margin: 0 15px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Name = styled.span`
  font-weight: 700;
  margin-left: 6px;
`;

const Status = styled.span<{ $color?: string }>`
  color: ${({ $color }) => $color || "#999"};
  font-size: 13px;
`;

const Money = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #1c9cea;
  margin: 8px 0;
`;

const Btn = styled.button`
  margin-left: 8px;
  background: #1c9cea;
  color: #fff;
  border: none;
  border-radius: 4px;
  width: 68px;
  height: 24px;
  font-size: 12px;
  cursor: pointer;
`;

const detailStatuses = [
  ...settleStatuses,
  ...timeoutStatuses,
  ...cancelStatuses,
  TakeOrderStatus.DELIVERY_TIMEOUT,
];

const TakeOrderCard = ({ order }: { order: any }) => {
  const { navigate } = useNavigation();
  const { userStore, chatStore, orderStore } = useStores();
  const {
    amount,
    seller_id,
    seller_username,
    username,
    status,
    payment_method,
    quantities,
    avatar,
  } = order || {};
  const isSeller = userStore.currentUser?.id === seller_id;
  const name = isSeller ? username : seller_username;
  const operation = isSeller ? "卖出" : "买入";
  const meta = orderStatusText[status] || { text: "未知状态", color: "#999" };

  const goDetail = () => {
    if (detailStatuses.includes(status)) {
      navigate("TakeOrderDetail", {
        id: order.id || order.trans_no || order.order_no,
      });
    }
  };

  const handleChat = () => {
    orderStore.onContactCs((user) => {
      const { chat_id } = genPrivacyChatID(userStore.currentUser.id, user.id);
      const chat = chatStore.chats.get(chat_id);
      if (chat) {
        chatStore.setCurrent(chat);
        navigate("Chat");
      }
    }, ToastError);
  };

  return (
    <Box onClick={goDetail}>
      <Row>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Avatar avatar={staticUrl(avatar)} name={name} />
          <Name>{name}</Name>
        </div>
        <Status $color={meta.color}>{meta.text}</Status>
      </Row>
      <Money>
        {formatPrice(Number(quantities || 0) * Number(amount || 0))}
      </Money>
      <Row>
        <span style={{ color: "#aaa", fontSize: 13 }}>
          {operation} {quantities} · {paymentMethodTextMap[payment_method] || "-"}
        </span>
        <div onClick={(e) => e.stopPropagation()}>
          <Btn onClick={handleChat}>客服</Btn>
        </div>
      </Row>
    </Box>
  );
};

export default observer(TakeOrderCard);
